import {FirestoreTimestamp, mapUserWriteToDb, UserWrite} from '@cp/model';
import {User as FirebaseUser} from 'firebase/auth';
import {getDoc, serverTimestamp, setDoc} from 'firebase/firestore';
import getUserDocRef from './getUserDocRef';

/**
 * Create user document only when it does not exist. Skips if doc already exists so
 * admin-set fields (e.g. roles) are never overwritten.
 */
export default async function createUserDoc(firebaseUser: FirebaseUser): Promise<void> {
  const ref = getUserDocRef(firebaseUser.uid);
  const snapshot = await getDoc(ref);
  if (snapshot.exists()) return;

  const write: UserWrite = {
    name: firebaseUser.displayName || undefined,
    email: firebaseUser.email || undefined,
    photoUrl: firebaseUser.photoURL || undefined,
  };
  const docData = mapUserWriteToDb(write, serverTimestamp() as unknown as FirestoreTimestamp);
  await setDoc(ref, docData);
}
